import { Link } from 'react-router-dom'
import {connect} from 'react-redux'

import moment from 'moment'
import { useState, useEffect, useRef } from 'react'
import { SelectBox } from 'devextreme-react/select-box';
import { Popover } from 'devextreme-react/popover';
//constants
import { REQUEST_STATUS, OPTION_STATUS } from "../../../constant/request.status"
import { REASONS_DECLINE, REASONS_INTERRUPTION ,REASONS_INTERRUPTION_TERMINATION} from "../../../constant/dictionary"

//components
import ActionButton from '../../assets/elements/button/action-button'
import FinalizedTag from '../../assets/elements/tag/finalized'
import Loading from '../../assets/controls/loading'


import CustomPopup from '../../assets/elements/custom-popup'
import CustomRadio from '../../assets/elements/input/custom-radio'
import CustomDate from '../../assets/elements/input/custom-date'
import CustomTextarea from '../../assets/elements/input/custom-textarea'
import RequestPopupData from './request-popup-data'
import RequestListSurvey from './request-list-survey';

//images
import ViewIcon from '../../../images/admin-icons/eye-icon.svg'
import {ReactComponent as TrashIcon} from '../../../images/admin-icons/trash-icon.svg'

//utils
import RequestHelper from '../../../utils/helper';
import { postReserveOption, 
    postDeclineOption, 
    putCancelBooking, 
    postRequestExtension,
    postRequestTermination, 
    putCancelReservation,
    putCancelPendingExtension,
    putCancelPendingTermination,
    putAcceptPendingExtension,
    putAcceptPendingTermination,
    putDeclinePendingTermination,
    putDeclinePendingExtension,
    putOnNotice,
    putClearNotice
 } from "../../../utils/my-requests"
//styles
import '../styles/request-properties-card-options.css'

const RequestPropertiesCard = ({ loading, option_id, metis_option_id, request_id, request_status, property_id, property_name, property_address, unit_size, distance, parking, property_grade, final_rate, floor_plan, dates_available, checkInDate, length_of_stay, floor_level, maid_service, telephone, ntv_requirement, option_status, currency_code,hiddeActions,bookedFilter,checkOutDate,extensions,completedExtensions,terminations,showSurveyReview,isReviewed ,requestReservationMapping, taxes, otherTaxesPerRateTypeUnit }) => {
    const [visibleDeclinedPopup, setVisibleDeclinedPopup] = useState(false)
    const [visiblePendingExtensionPopup, setVisiblePendingExtensionPopup] = useState(false)
    const [acceptPendingExtensionPopup, setAcceptPendingExtensionPopup] = useState(false)
    const [declinePendingExtensionPopup, setDeclinePendingExtensionPopup] = useState(false)
    const [acceptPendingTerminationPopup, setAcceptPendingTerminationPopup] = useState(false)
    const [declinePendingTerminationPopup, setDeclinePendingTerminationPopup] = useState(false)
    const [showActionsButtons, setShowActionsButtons] = useState(true)
    const [visibleCancelReservationPopup, setVisibleCancelReservationPopup] = useState(false)
    const [visibleCancelBookingPopup, setVisibleCancelBookingPopup] = useState(false)
    const [visibleRequestExtension, setVisibleRequestExtension] = useState(false)
    const [visibleRequestTermination, setVisibleRequestTermination] = useState(false)
    const [visiblePutOnNotice, setVisiblePutOnNotice] = useState(false)


    const [requestExtensionInfo, setRequestExtensionInfo] = useState(null)
    const [declinedReason, setDeclinedReason] = useState(null)
    const [commentDeclinedReason, setCommentDeclinedReason] = useState("")
    const [startDateRequestExtension,setStartDateRequestExtension] = useState(null)
    const [endDateRequestExtension, setEndDateRequestExtension] = useState(null)
    const [commentRequestExtensionReason, setCommentRequestExtensionReason] = useState("")
    const [yesNoList, setYesNoList] = useState([{ textLabel: "No", value: false }, { textLabel: "Yes", value: true }])
    const [placeUnitOnNotice, setPlaceUnitOnNotice] = useState(yesNoList[0])
    const [terminationDate, setTerminationDate] = useState(null)
    const [terminationComment, setTerminationComment] = useState("")
    const [localCompletedExtensions, setLocalCompletedExtensions] = useState([])
    const [localTerminations, setLocalTerminations] = useState([])
    const [currentDates, setCurrentDates] = useState(null)
    const dropDownBoxRef = useRef(null);
    const [ntvDate, setNtvDate] = useState(null)
    const [ntvComment, setNtvComment] = useState("")
    const [isOptionUnitOnNotice, setIsOptionUnitOnNotice] = useState(false)
    const Missing = () => {
        return (<span className='missing-text'>Missing</span>)
    }
    const messageColor = _ => {
        let yellowDate = moment().add(ntv_requirement, 'days').add(7, 'days');
        let redDate = moment().add(ntv_requirement, 'days');
        let endDate = moment(checkOutDate);
        if (redDate.isSameOrAfter(endDate, 'day')) {
            return 'red';
        } else if (yellowDate.isSameOrAfter(endDate, 'day')) {
            return 'yellow';
        } else {
            return 'none';
        }
    };

    const remainingDays = () => {
        const today = moment().startOf('day');
        const end = moment(checkOutDate).startOf('day');
        const deadline = moment(end).subtract(ntv_requirement, 'days');

        const diff = deadline.diff(today, 'days');

        return diff > 1 ? `${diff} days` : `${diff} day` 
    };

    const reserveOption = async() => {
        await postReserveOption(option_id, request_id);
        setCurrentStatus({...currentStatus, requestStatus: REQUEST_STATUS.ReservationCreated, optionStatus: OPTION_STATUS.PendingManager });
    }
    const cancelRequestTermination = _ => {
        setTerminationDate(null)
        setVisibleRequestTermination(false)
        setTerminationComment("")
    }
    const declineOption = async e => {
        e.preventDefault()

            await postDeclineOption(request_id,option_id, declinedReason?.id, commentDeclinedReason);
            setCurrentStatus({...currentStatus, requestStatus: REQUEST_STATUS.Quoted, optionStatus: OPTION_STATUS.DeclinedByRecipient });
            setVisibleDeclinedPopup(false)
    }
    const cancelDeclineOption = _ => {
        setVisibleDeclinedPopup(false)
        setDeclinedReason(null)
        setCommentDeclinedReason("")
    }
    const cancelReservation = async e => {
        e.preventDefault()
        await putCancelReservation(request_id, option_id);
        setVisibleCancelReservationPopup(false)
        setCurrentStatus({ ...currentStatus,requestStatus: REQUEST_STATUS.Quoted, optionStatus: OPTION_STATUS.Quoted })
    }

    const cancelBooking = async e => {
        e.preventDefault()
        await putCancelBooking(request_id, option_id);
        setVisibleCancelBookingPopup(false)
    }


    const [currentStatus, setCurrentStatus] = useState({});
    const setOnNotice = async e =>{
        e.preventDefault()
        let response = await putOnNotice(request_id, moment(ntvDate).format('YYYY-MM-DDTHH:mm:ss'), ntvComment)
        if(response)
        {
            setIsOptionUnitOnNotice(true)
           //hide message and button of put on notice
        }
        setVisiblePutOnNotice(false)
        // setNtvDate(null)
        // setNtvComment("")
    }
    const setClearNotice = async e =>{
        e.preventDefault()
        let response = await putClearNotice(request_id)
        if(response)
        {
            setIsOptionUnitOnNotice(false)
            setNtvDate(null)
            setNtvComment("")
        }
    }
    const requestExtension = async e =>{
        e.preventDefault()
        let response = await postRequestExtension(request_id, option_id, moment(startDateRequestExtension).format('YYYY-MM-DDTHH:mm:ss'), moment(endDateRequestExtension).format('YYYY-MM-DDTHH:mm:ss'), commentRequestExtensionReason, placeUnitOnNotice.value)
        if(response)
        {
            let data= {
                extensionId: response,
                startDate: moment(new Date(startDateRequestExtension).toISOString()).format(RequestHelper.getLocalDateFormat()),
                endDate: moment(new Date(endDateRequestExtension).toISOString()).format(RequestHelper.getLocalDateFormat()),
                comment: commentRequestExtensionReason,
                isPlacedUnitOnNotice: placeUnitOnNotice.value
            }
            setRequestExtensionInfo(data)
        }
        setVisibleRequestExtension(false)
        setEndDateRequestExtension(null)
        setCommentRequestExtensionReason("")
    }
    const requestTermination = async e => {
        e.preventDefault()
        let response = await postRequestTermination(request_id, option_id, moment(terminationDate).format('YYYY-MM-DDTHH:mm:ss') , terminationComment)
        
        if(response)
            {
                let data= {
                    extensionId: response,
                    terminationDate: moment(new Date(terminationDate).toISOString()).format(RequestHelper.getLocalDateFormat()),
                    residentComment: terminationComment,
                    termination: true
                }
                setRequestExtensionInfo(data)
            }
        cancelRequestTermination()
    }
    const cancelRequestExtension =  _ => {
        setVisibleRequestExtension(false)
        setEndDateRequestExtension(null)
        setCommentRequestExtensionReason("")
    }
    const cancelPendingTermination = async(e) => {
        try {
            e.preventDefault()
            await putCancelPendingTermination(request_id)
            setRequestExtensionInfo(null)
            setVisiblePendingExtensionPopup(false)
            setLocalTerminations([...localTerminations,{
                interruptionReasonId: 6,
                terminationDate: requestExtensionInfo.terminationDate
            }])
            // let [startMonth,startDay,startYear] = requestExtensionInfo.startDate.split("/")
            // let [endMonth,endDay,endYear] = requestExtensionInfo.endDate.split("/")

            // setLocalCompletedExtensions([...localCompletedExtensions,{
            //     startDate: `${startDay}/${startMonth}/${startYear}`,
            //     endDate: `${endDay}/${endMonth}/${endYear}`
            // }])
        } catch (error) {
        }
    }
    const cancelPendingExtension = async(e,id) => {
        try {
            e.preventDefault()
            await putCancelPendingExtension(id)
            setVisiblePendingExtensionPopup(false)
            setRequestExtensionInfo(null)

            // let [startMonth,startDay,startYear] = requestExtensionInfo.startDate.split("/")
            // let [endMonth,endDay,endYear] = requestExtensionInfo.endDate.split("/")
            
            setLocalCompletedExtensions([...localCompletedExtensions,{
                interruptionReasonId: 8,
                isPlacedUnitOnNotice: requestExtensionInfo.isPlacedUnitOnNotice,
                startDate: requestExtensionInfo.startDate,
                endDate: requestExtensionInfo.endDate
            }])
        } catch (error) {
        }
        
    }
    const acceptPendingExtension = async(e,extensionId) => {
        try {
            e.preventDefault()
            await putAcceptPendingExtension(extensionId,request_id)
            setRequestExtensionInfo({...requestExtensionInfo,statusId: 4})
            setAcceptPendingExtensionPopup(false)
        } catch (error) {
        }
        
    }
    const acceptPendingTermination = async(e) => {
        try {
            e.preventDefault()
            let response = await putAcceptPendingTermination(request_id) 
            if(response)
            {
                setShowActionsButtons(false)
                setAcceptPendingTerminationPopup(false)
                setLocalTerminations([...localTerminations,{
                    interruptionReasonId: 2,
                    terminationDate: requestExtensionInfo.terminationDate,
                    terminationFee: requestExtensionInfo.terminationFee,
                    ntv: requestExtensionInfo.ntv
                }])
            }
        } catch (error) {
        }
        
    }
    const declinePendingTermination = async(e,termination_id) => {
        try {
            e.preventDefault()
            await putDeclinePendingTermination(request_id,termination_id)
            setDeclinePendingTerminationPopup(false)
            setLocalTerminations([...localTerminations,{
                interruptionReasonId: 7,
                terminationDate: requestExtensionInfo.terminationDate,
                terminationFee: requestExtensionInfo.terminationFee,
                ntv: requestExtensionInfo.ntv
            }])
            setRequestExtensionInfo(null)
        } catch (error) {
        }
        
    }
    const declinePendingExtension = async(e,id) => {
        try {
            e.preventDefault()
            
            let response = await putDeclinePendingExtension(request_id, id, metis_option_id)
            setDeclinePendingExtensionPopup(false)

            if(response)
            {
                setRequestExtensionInfo(null)
                
                // let [startMonth,startDay,startYear] = requestExtensionInfo.startDate.split("/")
                // let [endMonth,endDay,endYear] = requestExtensionInfo.endDate.split("/")

                setLocalCompletedExtensions([...localCompletedExtensions,{
                    interruptionReasonId: 7,
                    isPlacedUnitOnNotice: requestExtensionInfo.isPlacedUnitOnNotice,
                    startDate: requestExtensionInfo.startDate,
                    endDate: requestExtensionInfo.endDate
                    // startDate: `${startDay}/${startMonth}/${startYear}`,
                    // endDate: `${endDay}/${endMonth}/${endYear}`
                }])
            }
                
        } catch (error) {
            setDeclinePendingExtensionPopup(false)
        }
        
    }
    useEffect(() => {
        setCurrentStatus({...currentStatus, requestStatus: request_status, optionStatus: option_status });
    }, [request_id,request_status])
    
    const OptionActionBtn = ({ currentStatus, requestExtensionInfo }) => {
        if(showActionsButtons)
        {
            if ((currentStatus.optionStatus === OPTION_STATUS.Quoted && currentStatus.requestStatus === REQUEST_STATUS.Quoted) || (currentStatus.requestStatus === REQUEST_STATUS.ReservationCreated && (currentStatus.optionStatus === OPTION_STATUS.New || currentStatus.optionStatus === OPTION_STATUS.Quoted))) {
                return (<>
                    <div className='request-properties-card-options__buttons__content__new'>
                        <div className='request-properties-card-options__buttons__content__new_content-wrapper'>
                            <div className='d-flex'>
                                <ActionButton action={reserveOption} disabled={currentStatus.requestStatus === REQUEST_STATUS.ReservationCreated || loading}>Reserve</ActionButton>
                                <Loading isVisble={loading} size={30}/>
                            </div>
                            {currentStatus.requestStatus === REQUEST_STATUS.ReservationCreated && 
                                <div className='request-properties-card-options__buttons__content__new__blocked-message'>
                                    <span>*</span>You should cancel current reservation, if you want to proceed with this option
                                </div>
                            }
                        </div>
                        
                    </div>
                    <div className='request-properties-card-options__buttons__content__new btn-cancel'>
                        <div className='d-flex'>
                            <ActionButton action={_ => setVisibleDeclinedPopup(true)} disabled={loading}>Decline</ActionButton>
                        </div>
                    </div>
    
                </>)
            } else if (currentStatus.optionStatus === OPTION_STATUS.DeclinedByRecipient || (REQUEST_STATUS.ReservationCreated === currentStatus.requestStatus && currentStatus.optionStatus !== OPTION_STATUS.PendingManager)) {
                return (<></>)
            } else if (currentStatus.requestStatus === REQUEST_STATUS.ReservationCreated && currentStatus.optionStatus === OPTION_STATUS.PendingManager) {
                return (<>
                    <div className='request-properties-card-options__buttons__content__new btn-cancel'>
                        <ActionButton action={_ => setVisibleCancelReservationPopup(true)}>Cancel Reservation</ActionButton>
                    </div>
                </>)
            } else if ((currentStatus.requestStatus === REQUEST_STATUS.Booked || currentStatus.requestStatus === REQUEST_STATUS.PendingExtension || currentStatus.requestStatus === REQUEST_STATUS.ExtensionRequested || currentStatus.requestStatus === REQUEST_STATUS.PendingTermination) && currentStatus.optionStatus === OPTION_STATUS.Booked) {
                if (moment(checkInDate).utcOffset(0).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).isAfter(moment())) {
                    return (<>
                        {!isOptionUnitOnNotice && 
                            <div>
                                <ActionButton action={_=>{setVisiblePutOnNotice(true)}} disabled={loading}>Put Unit On Notice</ActionButton>
                            </div>
                        }
                        {
                            isOptionUnitOnNotice &&
                            <div className='request-properties-card-options__message__unit-on-notice'>
                                <div className='request-properties-card-options__message__unit-on-notice__content'>
                                        <div className='request-properties-card-options__message__pending-extension__pending-confirmation__content__item'><span>Ntv Status :</span> <span style={{fontSize: '11px'}} className='request-properties-card-options__status__tag request-properties-card-options__status__tag--reserved'>On Notice</span></div>
                                        <div><span>Final End Date: </span>{ moment(ntvDate ? ntvDate : requestReservationMapping?.guestFinalEndDate).format(RequestHelper.getLocalDateFormat())}</div>
                                        <div><span>Comment: </span>{ntvComment ? ntvComment : requestReservationMapping?.guestNtvComment}</div>
                                        <div className='request-properties-card-options__message__pending-extension__cancel' onClick={setClearNotice}><TrashIcon/><span>Clear Notice</span><Loading isVisble={loading} size={20}/></div>
                                    </div>
                                </div>
                        }
                        <div className='request-properties-card-options__buttons__content__new btn-cancel'>
                            <ActionButton action={_ => setVisibleCancelBookingPopup(true)} disabled={request_status === REQUEST_STATUS.PendingExtension || loading}>Cancel Booking</ActionButton>
                        </div>
                    </>)
                } else {
                    if(!requestExtensionInfo)
                        return (<>
                            <div className='request-properties-card-options__buttons__content__new'>
                                <ActionButton disabled={isOptionUnitOnNotice} action={_=>setVisibleRequestExtension(true)}>Request Extension</ActionButton>
                                <ActionButton disabled={isOptionUnitOnNotice} action={_ => setVisibleRequestTermination(true)}>Request Termination</ActionButton>
                                {
                                    !isOptionUnitOnNotice && 
                                    <ActionButton action={_=>{setVisiblePutOnNotice(true)}} disabled={loading}>Put Unit On Notice</ActionButton>
                                }
                                {
                                    isOptionUnitOnNotice &&
                                        <div className='request-properties-card-options__message__unit-on-notice'>
                                            <div className='request-properties-card-options__message__unit-on-notice__content'>
                                                <div className='request-properties-card-options__message__pending-extension__pending-confirmation__content__item'><span>Ntv Status :</span> <span style={{fontSize: '11px'}} className='request-properties-card-options__status__tag request-properties-card-options__status__tag--reserved'>On Notice</span></div>
                                                <div><span>Final End Date: </span>{ moment(ntvDate ? ntvDate : requestReservationMapping?.guestFinalEndDate).format(RequestHelper.getLocalDateFormat())}</div>
                                                {(ntvComment || requestReservationMapping?.guestNtvComment) && <div><span>Comment: </span>{ntvComment ? ntvComment : requestReservationMapping?.guestNtvComment}</div>}
                                                <div className='request-properties-card-options__message__pending-extension__cancel' onClick={setClearNotice}><TrashIcon/><span>Clear Notice</span><Loading isVisble={loading} size={20}/></div>
                                            </div>
                                        </div>
                                }
                            </div>
                        </>)
                    else
                       return(<>
                        <div className='request-properties-card-options__message__pending-extension'>
                            {
                                (requestExtensionInfo.statusId === 6 ||  requestExtensionInfo.statusId === 4) && !requestExtensionInfo.termination ?
                                <>
                                    <div className='request-properties-card-options__message__pending-extension__pending-confirmation__title'>
                                        {requestExtensionInfo.statusId === 4 ? 'Pending to finalize extension:' : 'Extension approved by manager:'}
                                    </div>
                                    <div className='request-properties-card-options__message__pending-extension__pending-confirmation__content'>
                                        <div><span>Dates: </span>{requestExtensionInfo.startDate} - {requestExtensionInfo.endDate}</div>
                                               <div><span>Ntv Requirement : {`${requestExtensionInfo.ntvRequirement} days`}</span></div>
                                               <div><span>Extension Rate: </span>{requestExtensionInfo.finalRate} {currency_code}</div>
                                               <div><span>Placed Unit on Notice: </span>{requestExtensionInfo.isPlacedUnitOnNotice ? "Yes" : "No"}</div>
                                        {requestExtensionInfo.statusId === 6 && <div className='request-properties-card-options__message__pending-extension__pending-confirmation__buttons'>
                                            <div>
                                            <ActionButton action={()=>setAcceptPendingExtensionPopup(true)}>Accept</ActionButton>
                                            </div>
                                            
                                            <div className='request-properties-card-options__buttons__content__new btn-declined'>
                                                <ActionButton action={()=>setDeclinePendingExtensionPopup(true)}>Decline</ActionButton>
                                            </div>
                                        </div>}
                                    </div>
                                </>
                                :
                                (   requestExtensionInfo.termination && requestExtensionInfo.statusId === 5 
                                   ?
                                   <>
                                        <div className='request-properties-card-options__message__pending-extension__pending-confirmation__title'>
                                            Pending Termination to be confirmed
                                        </div>
                                        <div className='request-properties-card-options__message__pending-extension__pending-confirmation__content'>
                                            <div><span>Termination Date: </span>{requestExtensionInfo.terminationDate}</div>
                                            <div><span>Termination Fee: {requestExtensionInfo.terminationFee} {currency_code}</span></div>
                                            <div><span>Ntv Requirement: </span>{`${requestExtensionInfo.ntv} days`}</div>
                                            <div className='request-properties-card-options__message__pending-extension__pending-confirmation__buttons'>
                                                <div>
                                                <ActionButton action={()=>setAcceptPendingTerminationPopup(true)}>Accept</ActionButton>
                                                </div>
                                                
                                                <div className='request-properties-card-options__buttons__content__new btn-declined'>
                                                    <ActionButton action={()=>setDeclinePendingTerminationPopup(true)}>Decline</ActionButton>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                   :
                                   <>
                                    <div className='request-properties-card-options__message__pending-extension__title'>{requestExtensionInfo.termination ? 'Pending Termination:' : 'Pending Extension:'}</div>
                                    <div className='request-properties-card-options__message__pending-extension__dates'>{requestExtensionInfo.termination ? `Date: ${requestExtensionInfo.terminationDate}` : `Dates: ${requestExtensionInfo.startDate} - ${requestExtensionInfo.endDate}`}</div>
                                    {
                                        !requestExtensionInfo.termination &&
                                        <div className='request-properties-card-options__message__pending-extension__dates'>{`Placed Unit on Notice: ${requestExtensionInfo.isPlacedUnitOnNotice ? "Yes" : "No"}`}</div>

                                    }
                                    <div className='request-properties-card-options__message__pending-extension__comment'>{requestExtensionInfo.termination ? requestExtensionInfo.residentComment : requestExtensionInfo.comment}</div>
                                               
                                    <div className='request-properties-card-options__message__pending-extension__cancel' onClick={_=>setVisiblePendingExtensionPopup(true)}><TrashIcon/><span>Cancel</span></div>
                                </>
                                )
                                
                            }
                            
                        </div>
                        { !requestExtensionInfo.isPlacedUnitOnNotice && !requestExtensionInfo.termination && !isOptionUnitOnNotice && 
                            <div className='request-properties-card-options__buttons__content__new'>
                                <ActionButton action={_=>{setVisiblePutOnNotice(true)}} disabled={!requestExtensionInfo.isPlacedUnitOnNotice}>Put Unit On Notice</ActionButton>
                            </div>
                        }
                        
                       </>)
                }
            } 
        }
        else{
            return null
        }
        
    }

    const getStatusLabel = (statusId) => {
        switch (statusId) {
            case OPTION_STATUS.Quoted:
                return "new";
            case OPTION_STATUS.PendingSupplier:
            case OPTION_STATUS.PendingManager:
                return "pending manager";
            case OPTION_STATUS.Booked:
                return "booked";
            case OPTION_STATUS.DeclinedByRecipient:
                return "declined";
            default:
                return "error";
        }
    }

    const onPlaceUnitOnNoticeValueChanged = (e) => {
        setPlaceUnitOnNotice(e.selectedItem);
    }

    useEffect(() => {
      let data = null
      if(extensions?.length > 0 )
        {
            extensions.forEach(extension => {
                if(extension.statusId !== 5)
                {
                    data= {
                        ...extension,
                        startDate: moment(extension.startDate).format(RequestHelper.getLocalDateFormat()),
                        endDate: moment(extension.endDate).format(RequestHelper.getLocalDateFormat()),
                    }
                }
            })
        } 
      if(terminations?.length > 0)
      {
        let terminationLastIndex = terminations.length - 1
        let lastInterruptionId = terminations[terminationLastIndex]
        if(lastInterruptionId.interruptionReasonId === 2)
        {
            setShowActionsButtons(false)
        }
        else
        {
            terminations.forEach(termination => {
                if (!termination.interruptionReasonId)
                {
                    data= {
                        ...termination,
                        terminationDate: moment(termination.terminationDate).format(RequestHelper.getLocalDateFormat()),
                        termination: true
                    }
                }
            })
        }
      }
      setRequestExtensionInfo(data)
    }, [extensions,terminations])

    useEffect(() => {
      setLocalCompletedExtensions(completedExtensions)
      if(completedExtensions?.filter(item => item.interruptionReasonId === 5)?.length > 0 )
      {
        const latestDate = completedExtensions?.filter(item => item.interruptionReasonId === 5)?.reduce((latest,item) =>{
            const currentEndDate = new Date(item.originEndDate)
            const latestEndDate = new Date(latest.originEndDate)
            return currentEndDate > latestEndDate ? item : latest
        })
        setStartDateRequestExtension(latestDate.originEndDate)
      }
      else{
        setStartDateRequestExtension(checkOutDate)
      }
    }, [completedExtensions])
    useEffect(() => {
        let formattedStart = new Date (checkInDate)
          const dayStart = (formattedStart.getDate())
          const monthStart = (formattedStart.getMonth()+1)
          const yearStart = (formattedStart.getFullYear())
          formattedStart = `${dayStart}/${monthStart}/${yearStart}`
  
        if(completedExtensions?.filter(item => item.interruptionReasonId === 5)?.length > 0 )
        {
          const latestDate = completedExtensions?.filter(item => item.interruptionReasonId === 5)?.reduce((latest,item) =>{
              const currentEndDate = new Date(item.originEndDate)
              const latestEndDate = new Date(latest.originEndDate)
              return currentEndDate > latestEndDate ? item : latest
          })
          let formattedEnd = new Date (latestDate.originEndDate)
          const dayEnd = (formattedEnd.getDate())
          const monthEnd = (formattedEnd.getMonth()+1)
          const yearEnd = (formattedEnd.getFullYear())
          formattedEnd = `${dayEnd}/${monthEnd}/${yearEnd}`
          setCurrentDates({
              start: formattedStart,
              end: formattedEnd
            })
        }
        else{
          let formattedEnd = new Date (checkOutDate)
          const dayEnd = (formattedEnd.getDate())
          const monthEnd = (formattedEnd.getMonth()+1)
          const yearEnd = (formattedEnd.getFullYear())
          formattedEnd = `${dayEnd}/${monthEnd}/${yearEnd}`
          
          setCurrentDates({
              start: formattedStart,
              end: formattedEnd
            })
        }
    }, [checkInDate,checkOutDate,completedExtensions])
    
    useEffect(() => {
        let formattedTerminations = terminations.filter(item => item.interruptionReasonId !== null)
        formattedTerminations = formattedTerminations.map(item => 
         {
            let formattedDate = moment(item.terminationDate).format(RequestHelper.getLocalDateFormat())
            // const day = (formattedDate.getDate())
            // const month = (formattedDate.getMonth()+1)
            // const year = (formattedDate.getFullYear())
            return {
                ...item,
                terminationDate: formattedDate//`${month}/${day}/${year}`
            }
         }
        )
        setLocalTerminations(formattedTerminations)
    }, [terminations])
    useEffect(() => {
      if(requestReservationMapping?.guestFinalEndDate != null)
      {
        setIsOptionUnitOnNotice(true) 
      }
    }, [requestReservationMapping])

    const getTaxTypeString = (typeId) => {
        switch (typeId) {
            case 1: return "Local Tax"
            case 2: return "State Tax"
            case 3: return "City Tax"
            case 4: return "County Tax"
            case 5: return "VAT"
            case 6: return "Occupancy Tax"
            case 7: return "Other Tax"
            default: return "Other Tax"
        }
    }
    
  return (
    <div className='request-properties-card-options' style={bookedFilter ? currentStatus.optionStatus === 7 ? {} : {display:'none'} : {}}>
          <div className='request-properties-card-options__img'><img src={`${process.env.REACT_APP_PROPERTY_API_ENDPOINT}/api/v1/files/main-option-image/${property_id}`} alt="OptionImg" /></div>
          <div className='request-properties-card-options__put-unit-on-notice-message'>
            {!hiddeActions && currentStatus.optionStatus === OPTION_STATUS.Booked && currentStatus.requestStatus === REQUEST_STATUS.Booked && !requestExtensionInfo && !isOptionUnitOnNotice && 
                <div className={`request-properties-card-options__status__message request-properties-card-options__status__message--${messageColor()}`}>
                    {messageColor() === 'red' ? 'Please provide a notice as soon as possible, otherwise additional costs may be charged.' : `There are only ${remainingDays()} to put unit on notice, otherwise you may request an extension.`}
                </div>
            }
          </div>
        <div className='request-properties-card-options__information'>
            <div className='request-properties-card-options__information__content'>
                <div className='request-properties-card-options__information__left'>
                    <div className='request-properties-card-options__information__field request-properties-card-options__information__field__option-id'>
                        {/*<div className='request-properties-card-options__information__field__name'>Option Id:</div>*/}
                        {/*<div className='request-properties-card-options__information__field__value'>{option_id}</div>*/}
                          <div className='request-properties-card-options__field-status'>
                            <span className={`request-properties-card-options__status__tag ${currentStatus.optionStatus === 2 ? 'request-properties-card-options__status__tag--new' : 'request-properties-card-options__status__tag--reserved'}`}>{getStatusLabel(currentStatus.optionStatus)}</span>
                          </div>
                    </div>
                    <div className='request-properties-card-options__information__field request-properties-card-options__information__field__property-name'>
                        <div className='request-properties-card-options__information__field__name'>Property #:</div>
                        <Link className='request-properties-card-options__information__field__value request-properties-card-options__information__field__value--link' to={`/property/dashboard/${property_id}`} target='_blank'>{property_id}</Link>
                    </div>
                    <div className='request-properties-card-options__information__field'>
                        <div className='request-properties-card-options__information__field__name'>Property Address:</div>
                        <div className='request-properties-card-options__information__field__value'>{property_address}</div>
                    </div>
                    <div className='request-properties-card-options__information__field'>
                          <div className='request-properties-card-options__information__field__name'>Unit Size:</div>
                          <div className='request-properties-card-options__information__field__value'>{unit_size ?? <Missing />}</div>
                    </div>
                    <div className='request-properties-card-options__information__field'>
                        <div className='request-properties-card-options__information__field__name'>Distance:</div>
                        <div className='request-properties-card-options__information__field__value'>{distance.toFixed(2)} miles</div>
                    </div>
                    <div className='request-properties-card-options__information__field'>
                        <div className='request-properties-card-options__information__field__name'>Parking:</div>
                        <div className='request-properties-card-options__information__field__value'>{parking}</div>
                    </div>
                    <div className='request-properties-card-options__information__field'>
                        <div className='request-properties-card-options__information__field__name'>Property Grade:</div>
                          <div className='request-properties-card-options__information__field__value'>{property_grade ?? <Missing />}</div>
                    </div>
                </div>
                <div className='request-properties-card-options__information__right'>
                    <div className='request-properties-card-options__information__field request-properties-card-options__information__field--tax'>
                        <div className='request-properties-card-options__information__field__name'>Final Rate:</div>
                          <div className='request-properties-card-options__information__field__value'>
                              {
                                  taxes.length == 0 ? 
                                      <div className='request-properties-card-options__information__field__value__tax'>{`${currency_code} ${final_rate}`}
                                          <span id={`details-popover-${option_id}`} className='request-properties-card-options__information__field__value__tax-icon tax-icon__green'> &#x2713;</span>
                                      </div> 
                                      :
                                      <div className='request-properties-card-options__information__field__value__tax'>{` ${currency_code} ${(final_rate + otherTaxesPerRateTypeUnit).toFixed(2)} (${final_rate} + Tax: ${otherTaxesPerRateTypeUnit} `}
                                          <span id={`details-popover-${option_id}`} className='request-properties-card-options__information__field__value__tax-icon'>i</span>
                                      </div> 
                              }
                            <div className='request-properties-card-options__information__field__value__tax'> 
                                  {
                                      taxes.length > 0 ?
                                      <Popover
                                          target={`#details-popover-${option_id}`}
                                          position="right"
                                          showEvent={"mouseover"}
                                      >
                                          <div className="taxes-popover">
                                              <div><b>Taxes:</b></div>
                                              <div className="taxes-block">
                                                      {taxes.map((tax, index) =>
                                                          <div key={`tax-record-${index}`} className="tax-record">
                                                          <span>{getTaxTypeString(tax.taxTypeId)}: </span>
                                                          {
                                                              tax.taxValueTypeId === 3 ?
                                                                      <span>{tax.value} % <i>{`${tax.taxDescription && '(' + tax.taxDescription + ')'}`}</i></span>
                                                                  :
                                                                 <span>{` ${tax.currency.code} ${tax.value}`} <i>{`${tax.taxDescription && '(' + tax.taxDescription +')'}`}</i> </span>
                                                          }
                                                      </div>
                                                  )}
                                              </div>
                                          </div>
                                          </Popover>
                                          :
                                          <Popover
                                              target={`#details-popover-${option_id}`}
                                              position="right"
                                              showEvent={"mouseover"}
                                          >
                                              <div className="taxes-popover">
                                                  <div><b>Taxes Included</b></div>
                                              </div>
                                          </Popover>
                                  }
                            </div>
                        </div>
                    </div>
                    <div className='request-properties-card-options__information__field'>
                        <div className='request-properties-card-options__information__field__name'>Floor Plan:</div>
                        <div className='request-properties-card-options__information__field__value'>{floor_plan}</div>
                    </div>
                    <div className='request-properties-card-options__information__field'>
                        <div className='request-properties-card-options__information__field__name'>Dates Available:</div>
                        <div className='request-properties-card-options__information__field__value'>{dates_available}</div>
                    </div>
                    <div className='request-properties-card-options__information__field'>
                        <div className='request-properties-card-options__information__field__name'>Length Of Stay:</div>
                        <div className='request-properties-card-options__information__field__value'>{length_of_stay}</div>
                    </div>
                    <div className='request-properties-card-options__information__field'>
                        <div className='request-properties-card-options__information__field__name'>Floor Level:</div>
                          <div className='request-properties-card-options__information__field__value'>{floor_level ?? <Missing />}</div>
                    </div>
                    <div className='request-properties-card-options__information__field'>
                        <div className='request-properties-card-options__information__field__name'>Maid Service:</div>
                        <div className='request-properties-card-options__information__field__value'>{maid_service}</div>
                    </div>
                    <div className='request-properties-card-options__information__field'>
                        <div className='request-properties-card-options__information__field__name'>Telephone:</div>
                          <div className='request-properties-card-options__information__field__value'>{telephone ?? <Missing />}</div>
                    </div>
                    <div className='request-properties-card-options__information__field'>
                        <div className='request-properties-card-options__information__field__name'>Ntv Requirement:</div>
                        <div className='request-properties-card-options__information__field__value'>{`${ntv_requirement} days`}</div>
                    </div>
                </div>
                <div className='request-properties-card-options__information__extension-list'>
                        {localCompletedExtensions?.length > 0 &&  option_status === OPTION_STATUS.Booked &&
                        <>
                            <div className='request-properties-card-options__information__extension-list__separator'></div>
                            <div className='request-properties-card-options__information__extension-list__content'>
                                
                                <div><span>Extensions:</span></div>
                                <div>
                                    {localCompletedExtensions.map((item,index) => 
                                        <div key={`extension-list${option_id}${index}`}>
                                            <div className='request-properties-card-options__information__extension-list__content__centered'><span>Extension Dates:</span> {item.startDate} - {item.endDate} <span className='request-properties-card-options__information__extension-list__content__tag' style={item.interruptionReasonId === 5 ? { backgroundColor: '#05b15a' } : { backgroundColor: '#d43f3a' }}>{item.interruptionReasonId === 5 ? 'Approved' : REASONS_INTERRUPTION.filter(reason => reason.id == item.interruptionReasonId)[0]?.name}</span></div>
                                            <div className='request-properties-card-options__information__extension-list__content__centered'><span>Placed Unit on Notice:</span> {`${item.isPlacedUnitOnNotice ? "Yes" : "No"}`}</div>
                                            {item.ntvRequirement && <div className='request-properties-card-options__information__extension-list__content__centered'><span>Ntv Requirement:</span> {`${item.ntvRequirement} days`}</div>}
                                            {item.finalRate && <div className='request-properties-card-options__information__extension-list__content__centered'><span>Final Rate:</span> {item.finalRate} {currency_code}</div>}
                                            {localCompletedExtensions?.length > (index + 1)  && <hr />}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </>
                            
                        }
                        {
                            localTerminations.length > 0 &&  option_status === OPTION_STATUS.Booked &&
                            <>
                            <div className='request-properties-card-options__information__extension-list__separator'></div>
                            <div className='request-properties-card-options__information__extension-list__content'>
                                
                                <div><span>Terminations:</span></div>
                                <div>
                                    {localTerminations.map((item,index) => 
                                        <div key={`termination-list${option_id}${index}`}>
                                            <div className='request-properties-card-options__information__extension-list__content__centered'><span>Termination Date:</span> { item.terminationDate } <span className='request-properties-card-options__information__extension-list__content__tag' style={item.interruptionReasonId === 2 ? {backgroundColor: '#05b15a'}: {backgroundColor: '#d43f3a'}}>{item.interruptionReasonId === 2 ? 'Approved' : REASONS_INTERRUPTION_TERMINATION.filter(reason => reason.id == item.interruptionReasonId)[0]?.name}</span></div>
                                            {item.terminationFee && <div className='request-properties-card-options__information__extension-list__content__centered'><span>Termination Fee:</span> {item.terminationFee} {currency_code}</div>}
                                            {item.ntv && <div className='request-properties-card-options__information__extension-list__content__centered'><span> Ntv Requirement:</span> {`${item.ntv} days`}</div>}
                                            {localTerminations.length > (index + 1)  && <hr />}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </>
                        }
                </div>
            </div>
        </div>
        <div className='request-properties-card-options__title'>
            <div className='request-properties-card-options__information__field'>
                <div className='request-properties-card-options__information__field__name'>Option Id:</div>
                <div className='request-properties-card-options__information__field__value'>{option_id}</div>
                  <div className='request-properties-card-options__field-status'>
                    <span className={`request-properties-card-options__status__tag ${currentStatus.optionStatus === 2 ? 'request-properties-card-options__status__tag--new' : 'request-properties-card-options__status__tag--reserved'}`}>{getStatusLabel(currentStatus.optionStatus)}</span>
                  </div>
             </div>
            <div className='request-properties-card-options__information__field'>
                <div className='request-properties-card-options__information__field__name'>Property Name:</div>
                <div className='request-properties-card-options__information__field__value'>{property_name}</div>
            </div>
        </div>
        <div className='request-properties-card-options__status'>
            <span className={`request-properties-card-options__status__tag ${showSurveyReview && currentStatus.optionStatus === OPTION_STATUS.Booked ? 'request-properties-card-options__status__tag--finalized' : ''} ${currentStatus.optionStatus === 2 ? 'request-properties-card-options__status__tag--new' : 'request-properties-card-options__status__tag--reserved'}`}>{showSurveyReview && currentStatus.optionStatus === OPTION_STATUS.Booked ? <FinalizedTag /> : getStatusLabel(currentStatus.optionStatus)}</span>
        </div>
        {showSurveyReview && currentStatus.optionStatus === OPTION_STATUS.Booked && <div className='request-properties-card-options__information__survey'><RequestListSurvey propertyId={property_id} requestId={request_id} optionId={option_id} loading={loading} isReviewed={isReviewed}/></div>}

        <div className='request-properties-card-options__buttons'>
            <div className='request-properties-card-options__buttons__content'>
                {/* <Link target='_blank' to={`/property/dashboard/${id}`} className='request-properties-card-options__buttons__content__view'><img src={ViewIcon}/><span>View</span></Link> */}
                <Link className='request-properties-card-options__buttons__content__view' to={`/my-requests/option/${request_id}/${option_id}`} target='_blank'><img src={ViewIcon}/><span>Option Preview</span></Link>
                {/* <Link className='request-properties-card-options__buttons__content__view' to={`/property/dashboard/${property_id}`} target='_blank'><img src={ViewIcon}/><span>Property Preview</span></Link> */}
                {/* <div className='request-properties-card-options__buttons__content__delete'><img src={DeleteIcon}/><span>Delete</span></div> */}
                {/*
                      currentStatus.optionStatus === 2 && currentStatus.requestStatus === 2 ? 
                    <div className='request-properties-card-options__buttons__content__new'>
                              <ActionButton action={reserveOption}>Reserve</ActionButton>
                        <div className='request-properties-card-options__buttons__content__decline'>Decline</div>
                    </div>
                    :
                    <div className='request-properties-card-options__buttons__content__cancel'>
                        <span>X</span><span>Cancel</span>
                          </div>
  */
                    !hiddeActions && <OptionActionBtn  currentStatus={currentStatus} requestExtensionInfo={requestExtensionInfo}/>
                    // <OptionActionBtn />
                }                
            </div>
        </div>
        <div className='request-properties-card-options__divisor'></div>
        <CustomPopup 
            visible={visiblePutOnNotice} 
            onHiding={_ => visiblePutOnNotice(false)}
        >
            <RequestPopupData 
                title='PUT UNIT ON NOTICE' 
                // id={requestExtensionInfo?.extensionId} 
                message={`Please setup NTV Date if you won't going to extend your reservation.`}
                isButtonGreen={true}
                buttonPaddingLeft='155px'
                labelAction='Put Unit On Notice' 
                labelCancel='Cancel' 
                action={setOnNotice}
                setVisible={setVisiblePutOnNotice}
                disabled={loading}
                // CancelButton={cancelRequestExtension}
            >
                <div className='request-properties-card-options__field'>
                    <div className='request-properties-card-options__field__label'><span>Reservation Dates:</span></div>
                    <div className='request-properties-card-options__field__value'>{currentDates?.start} - {currentDates?.end}</div>
                </div>
                <div>
                    <CustomDate 
                        labelSize='143px'
                        label='NTV Date'
                        value={ntvDate}
                        setValue={setNtvDate}
                        requiredValue={true}
                        dateFormat={RequestHelper.getLocalDateFormat() }
                        min={(new Date(new Date(checkInDate).getTime())).toISOString()}
                        max={(new Date(new Date(checkOutDate).getTime())).toISOString()}
                    />
                </div>

                <div>
                    <CustomTextarea 
                        labelSize='143px' 
                        label='Your Comment' 
                        value={ntvComment} 
                        setValue={setNtvComment} 
                        requiredValue={false}/>
                </div>
            </RequestPopupData>
        </CustomPopup>

        <CustomPopup visible={visibleDeclinedPopup} onHiding={_ => setVisibleDeclinedPopup(false)}>
            <RequestPopupData 
                title='DECLINE THE OPTION' 
                id={option_id} 
                message='To help us provide better option for you, please choose the reason why this option does not fit for you.'
                labelAction='Decline' 
                labelCancel='Cancel' 
                action={declineOption}
                buttonPaddingLeft='145px'
                closeAction={cancelDeclineOption}
                setVisible={setVisibleDeclinedPopup}
                disabled={loading}
            >
                <div>
                    <div>
                        <CustomRadio labelSize='133px' label='Reason to decline' value={declinedReason} setValue={setDeclinedReason} requiredValue={true} items={REASONS_DECLINE} type={'vertical'}/>
                    </div>
                    <div>
                        <CustomTextarea labelSize='133px' label='Your Comment' value={commentDeclinedReason} setValue={setCommentDeclinedReason} requiredValue={false}/>
                    </div>
                </div>
            </RequestPopupData>
            
        </CustomPopup>
        <CustomPopup visible={visibleCancelReservationPopup} closeOnlyButtons={true} onHiding={_ => setVisibleCancelReservationPopup(false)}>
        <RequestPopupData 
            title='CANCEL RESERVATION FOR THE OPTION' 
            id={option_id} 
            message='After you cancel reservation you will be able to reserve another option.'
            labelAction='Cancel Reservation' 
            labelCancel='Cancel' 
            action={cancelReservation}
            setVisible={setVisibleCancelReservationPopup}
            disabled={loading}
        />
        
        </CustomPopup>
        <CustomPopup visible={visibleCancelBookingPopup} closeOnlyButtons={true} onHiding={_ => setVisibleCancelBookingPopup(false)}>
            <RequestPopupData 
                title='REQUEST BOOKING CANCELLATION' 
                // id={option_id} 
                message='Our managers are required to approve booking cancellation.'
                labelAction='Cancel Booking' 
                labelCancel='Close' 
                action={cancelBooking}
                setVisible={setVisibleCancelBookingPopup}
                disabled={loading}
            />
        </CustomPopup>
        <CustomPopup visible={visiblePendingExtensionPopup} onHiding={_ => setVisiblePendingExtensionPopup(false)}>
        <RequestPopupData 
            title={requestExtensionInfo?.termination ? 'ARE YOU SURE YOU WANT TO CANCEL A TERMINATION FOR REQUEST' : 'CANCEL PENDING EXTENSION FOR THE REQUEST'}
            titleId = {request_id}
            id={requestExtensionInfo?.extensionId} 
            message='' 
            labelAction={requestExtensionInfo?.termination ? 'Cancel' : 'Cancel Pending Extension'}
            labelCancel='Close' 
            action={requestExtensionInfo?.termination ? cancelPendingTermination : cancelPendingExtension}
            setVisible={setVisiblePendingExtensionPopup}
            disabled={loading}
        />
        
        </CustomPopup>
        <CustomPopup visible={acceptPendingExtensionPopup || acceptPendingTerminationPopup} onHiding={_ => {acceptPendingExtensionPopup ? setAcceptPendingExtensionPopup(false) : setAcceptPendingTerminationPopup(false)}}>
        <RequestPopupData 
            title= {acceptPendingExtensionPopup ? 'ACCEPT PENDING EXTENSION' : 'ACCEPT PENDING TERMINATION'}
            titleId = {request_id}
            id={acceptPendingExtensionPopup ? requestExtensionInfo?.extensionId : requestExtensionInfo?.id} 
            message='Are you sure you want to accept current requirements?' 
            isButtonGreen={true}
            labelAction='Yes' 
            labelCancel='No' 
            action={acceptPendingExtensionPopup ? acceptPendingExtension : acceptPendingTermination}
            setVisible={acceptPendingExtensionPopup ? setAcceptPendingExtensionPopup : setAcceptPendingTerminationPopup}
            disabled={loading}
        />
        
        </CustomPopup>
        <CustomPopup visible={declinePendingTerminationPopup || declinePendingExtensionPopup} onHiding={_ => {declinePendingTerminationPopup ? setDeclinePendingTerminationPopup(false) : setDeclinePendingExtensionPopup(false)}}>
        <RequestPopupData 
            title= {`DECLINE PENDING ${declinePendingExtensionPopup ? 'EXTENSION' : 'TERMINATION'}`}
            titleId = {request_id}
            id={declinePendingTerminationPopup ? requestExtensionInfo?.id : requestExtensionInfo?.extensionId} 
            message='Are you sure you want to decline?' 
            isButtonGreen={true}
            labelAction='Yes' 
            labelCancel='No' 
            action={declinePendingTerminationPopup ? declinePendingTermination : declinePendingExtension}
            setVisible={declinePendingTerminationPopup ? setDeclinePendingTerminationPopup : setDeclinePendingExtensionPopup}
            disabled={loading}
        />
        
        </CustomPopup>
        <CustomPopup visible={visibleRequestExtension} onHiding={_ => setAcceptPendingExtensionPopup(false)}>
        <RequestPopupData 
            title='CREATE EXTENSION' 
            // id={requestExtensionInfo?.extensionId} 
            message='If you want to extend your request, please choose the preferred end date.' 
            isButtonGreen={true}
            buttonPaddingLeft='155px'
            labelAction='Send' 
            labelCancel='Cancel' 
            action={requestExtension}
            setVisible={cancelRequestExtension}
            disabled={loading}
            CancelButton={cancelRequestExtension}
        >
            <div className='request-properties-card-options__field'>
                <div className='request-properties-card-options__field__label'><span>Reservation Dates:</span></div>
                <div className='request-properties-card-options__field__value'>{currentDates?.start} - {currentDates?.end}</div>
            </div>
            <div>
                <CustomDate 
                    labelSize='143px'
                    label='End Date'
                    value={endDateRequestExtension}
                    setValue={setEndDateRequestExtension}
                    requiredValue={true}
                    dateFormat={RequestHelper.getLocalDateFormat() }
                    min={(new Date(new Date(startDateRequestExtension).getTime() + (24*60*60*1000))).toISOString()}
                />
            </div>
                  <div className='request-properties-card-options__place_on_notice_block'>
                      <div className="label"><span>Place Unit on Notice:</span></div>
                      <SelectBox  
                          dataSource={yesNoList}
                          displayExpr={(item) =>
                              item.textLabel
                          }
                          value={placeUnitOnNotice}
                          ref={dropDownBoxRef}
                          onSelectionChanged={onPlaceUnitOnNoticeValueChanged}
                      >
                        </SelectBox>
                  </div>
            <div>
                <CustomTextarea labelSize='143px' label='Your Comment' value={commentRequestExtensionReason} setValue={setCommentRequestExtensionReason} requiredValue={false}/>
            </div>
        </RequestPopupData>
        
        </CustomPopup>
        <CustomPopup visible={visibleRequestTermination} onHiding={_ => setVisibleRequestTermination(false)}>
            <RequestPopupData 
                title='REQUEST TERMINATION' 
                message='If you want to request a termination, please choose the preferred end date.' 
                isButtonGreen={true}
                buttonPaddingLeft='145px'
                labelAction='Request' 
                labelCancel='Cancel' 
                action={requestTermination}
                setVisible={setVisibleRequestTermination}
                disabled={loading}
                closeAction={cancelRequestTermination}
            >
                <div className='request-properties-card-options__field'>
                    <div className='request-properties-card-options__field__label'><span>Reservation Dates:</span></div>
                    <div className='request-properties-card-options__field__value'>{currentDates?.start} - {currentDates?.end}</div>
                </div>
                <div>
                    <CustomDate 
                        labelSize='133px'
                        label='End Date'
                        value={terminationDate}
                        setValue={setTerminationDate}
                        requiredValue={true}
                        dateFormat={RequestHelper.getLocalDateFormat() }
                        min={(new Date(new Date(checkInDate).getTime())).toISOString()}
                        max={(new Date(new Date(startDateRequestExtension).getTime())).toISOString()}
                    />
                </div>
                <div>
                    <CustomTextarea labelSize='133px' label='Your Comment' value={terminationComment} setValue={setTerminationComment} requiredValue={false}/>
                </div>
            </RequestPopupData>
        </CustomPopup>
    </div>
  )
}
function mapStateToProps({ requests }) {
    return {
        loading: requests.loading,
    };
  }

export default connect(mapStateToProps)(RequestPropertiesCard)
